<template>
  <v-container class="px-5 pt-7">
    <v-row>
      <v-col>
        <h1 class="mb-7">
          Notifications
        </h1>
        <v-expansion-panels>
          <v-expansion-panel>
            <div class="pa-3">
              <div class="d-flex align-center">
                <div
                  class="school-logo"
                  style="border-color: #002664"
                >
                  <v-img
                    src="/NSWGov_Logo.png"
                    height="22"
                    width="22"
                  />
                </div>
                <div class="mb-0 ml-4 d-flex align-center">
                  <p class="mb-0 font-weight-medium black--text">
                    NSW Department of Education
                  </p>
                  <div
                    class="black--text text-body-2"
                    style="line-height: 1"
                  >
                    <v-switch v-model="appFilters.newsFilter[0].value" />
                  </div>
                </div>
              </div>
            </div>
          </v-expansion-panel>
          <v-expansion-panel
            v-for="(school, i) in schoolsExpansionPanel"
            :key="i"
          >
            <v-expansion-panel-header class="pa-3">
              <div class="d-flex align-center">
                <div
                  class="school-logo"
                  :style="`border-color: ${school.details.colour}`"
                >
                  <v-img
                    :src="school.details.logo"
                    width="22"
                    height="22"
                    contain
                    class="flex-shrink-0 flex-grow-0"
                  />
                </div>
                <div class="mb-0 ml-4">
                  <p class="mb-1 font-weight-medium black--text">
                    {{ school.details.name }}
                  </p>
                  <div
                    class="black--text text-body-2"
                    style="line-height: 1"
                  >
                    {{ school.filters.length - 1 }} available,
                    {{ getSelected(school.filters, school.schoolId) }} selected
                  </div>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list>
                <v-list-item
                  v-for="(tag, index) in school.filters.slice(0, 1)"
                  class="px-0"
                  :key="index"
                >
                  <v-list-item-icon>
                    <v-icon color="success">
                      mdi-all-inclusive
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="pa-0 black--text">
                    <v-list-item-title :v-text="$t('news.personalise.hide')" />
                  </v-list-item-content>
                  <v-list-item-action class="my-1">
                    <v-switch
                      :input-value="getSchoolNewsFilter(school.schoolId)"
                      @click="toggleSchoolNewsFilter(school.schoolId)"
                    />
                  </v-list-item-action>
                </v-list-item>
                <v-list-item
                  v-for="(tag, index) in school.filters.slice(1)"
                  class="px-0"
                  :key="index + 1"
                >
                  <v-list-item-icon>
                    <v-icon color="success">
                      mdi-bell-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="pa-0 black--text">
                    <v-list-item-title v-text="tag.id" />
                  </v-list-item-content>
                  <v-list-item-action class="my-1">
                    <v-switch
                      v-if="getSchoolNewsFilter(school.schoolId)"
                      :input-value="false"
                      @click="toggleSchoolNewsFilter(school.schoolId, tag.id)"
                    />
                    <v-switch
                      v-else
                      v-model="tag.value"
                    />
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <AdsButton
          button-text="Clear all selections"
          :secondary="true"
          icon="mdi-minus-circle-outline"
          class="mt-8"
          @click="resetPersonalisation"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { AdsButton } from "@nswdoe/doe-ui-core";
import { mapGetters } from "vuex";
import {
  FA_SCREEN_VIEW,
  FA_SCREEN_CLASS,
  FA_SCREEN_NAME
} from "@/settings/constants";

const Notifications = {
  name: "Notifications",
  components: {
    AdsButton
  },
  computed: {
    ...mapGetters(["mySchools", "appFilters"]),
    schoolsExpansionPanel: function() {
      return this.mySchools.map(school => {
        let schoolFilters = this.appFilters.newsPersonalisation.find(
          filter => filter.id === school.schoolId
        );
        school.filters = schoolFilters.filters;
        return school;
      });
    }
  },
  data() {
    return {
      allFilters: true
    };
  },
  props: {
    title: String
  },
  created: function() {
    this.analytics(FA_SCREEN_VIEW, {
      [FA_SCREEN_CLASS]: "news",
      [FA_SCREEN_NAME]: "personalise_feed"
    });
    if (!this.$store.getters.schools.length) {
      this.$store.dispatch("getSchools");
    }
  },
  methods: {
    getSelected: function(filters, schoolId) {
      // check to see if we're hiding all news for the school
      // (negative check to maintain users preference from earlier implementation)
      let showFilters = this.appFilters.newsFilter.find(
        school => school.id === schoolId
      ).value;
      // if we are, return '0 selected' otherwise return the number of active filters
      if (!showFilters) {
        return 0;
      } else {
        return filters.filter(tag => tag.value).length;
      }
    },
    resetPersonalisation: function() {
      this.$store.dispatch("resetPersonalisation");
    },
    togglePersonalisation: function(school) {
      this.$store.dispatch("togglePersonalisation", school.schoolId);
    },
    toggleSchoolNewsFilter: function(schoolId, tag) {
      let data = {
        schoolId: schoolId,
        tag: tag
      };
      this.$store.dispatch("toggleSchoolNewsFilter", data);
    },
    getSchoolNewsFilter: function(schoolId) {
      return !this.appFilters.newsFilter.find(school => school.id === schoolId)
        .value;
    }
  },
  watch: {
    title() {
      this.filter = this.mySchools.map((school, i) => {
        let schoolId = school.schoolId;
        return {
          id: schoolId,
          value: this.appFilters[i] ? this.appFilters[i].value : false
        };
      });
      console.log("app Filter changes");
    }
  }
};
export default Notifications;
</script>
<style scoped>
.v-list-item__title {
  text-transform: capitalize;
}
.school-logo {
  padding: 7px;
  border: 2px solid;
  border-radius: 100px;
}
</style>
